module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('page-title', {
    attrs: {
      "title": _vm.title
    }
  }), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    attrs: {
      "id": "contact-list"
    }
  }, [_c('li', [_vm._v("Phone: "), _c('a', {
    attrs: {
      "href": "tel:530-556-5605"
    }
  }, [_vm._v("530-556-5605")])]), _vm._v(" "), _c('li', [_vm._v("Email: "), _c('a', {
    attrs: {
      "href": "mailto:jonathan@studio308.co"
    }
  }, [_vm._v("jonathan@studio308.co")]), _vm._v(" or "), _c('a', {
    attrs: {
      "href": "mailto:jonny@jonnypickett.com"
    }
  }, [_vm._v("jonny@jonnypickett.com")])]), _vm._v(" "), _c('li', [_vm._v("Company Site: "), _c('a', {
    attrs: {
      "href": "https://www.studio308.co"
    }
  }, [_vm._v("https://www.studio308.co")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0932a04c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contact.vue
// module id = 67
// module chunks = 0